export default __webpack_public_path__ + "static/media/special-opportunities-fund-desktop.999651f5.webp";